export default function OtpInputGroup({
  digits,
  onDigitChange,
  onDigitKeyDown,
  onDigitPaste,
  inputRefs,
  disabled = false,
}) {
  return (
    <div className="mb-8 flex justify-between gap-2">
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={(node) => {
            inputRefs.current[index] = node
          }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(event) => onDigitChange(index, event.target.value)}
          onKeyDown={(event) => onDigitKeyDown(index, event)}
          onPaste={onDigitPaste}
          disabled={disabled}
          className="h-14 w-12 rounded-t-lg border-0 border-b-2 border-surface-variant bg-surface-container-low text-center font-display text-[34px] font-bold text-on-surface outline-none transition-all focus:border-primary focus:bg-surface-container-lowest disabled:cursor-not-allowed disabled:opacity-70"
          placeholder="."
        />
      ))}
    </div>
  )
}

